import {
  Model,
} from '@vuex-orm/core';

export default class extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'tag'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields() {
    return {
      id: this.number(0),
      name: this.string(''),
      slug: this.string(''),
      type: this.string(''),
      extra: this.attr({}),
    };
  }

  static methodConf = {
    http: {
      url: '/api/fetcher',
    },
    methods: {
      $fetch: {
        name: 'fetch',
        http: {
          url: '/tags',
          method: 'get',
        },
      },
      $get: {
        name: 'get',
        http: {
          url: '/tags/:id',
          method: 'get',
        },
      },
      $create: {
        name: 'create',
        http: {
          url: '/tags',
          method: 'post',
        },
      },
      $update: {
        name: 'update',
        http: {
          url: '/tags/:id',
          method: 'put',
        },
      },
      $delete: {
        name: 'delete',
        http: {
          url: '/tags/:id',
          method: 'delete',
        },
      },
    },
  }
}
